import React from "react";
import { Box, Checkbox, Typography } from "@mui/material";

type Props = {
  isPTOLetterFilter: boolean;
  togglePTOLetterFilter: () => void;
};

const PtoLetterCheckbox = ({
  isPTOLetterFilter,
  togglePTOLetterFilter,
}: Props) => {
  return (
    <Box
      onClick={() => togglePTOLetterFilter()}
      sx={{
        display: "flex",
        alignItems: "center",
        padding: "6px 12px 6px 6px",
        cursor: "pointer",
      }}
    >
      <Checkbox
        checked={isPTOLetterFilter}
        onClick={(event) => event.stopPropagation()}
        onChange={() => togglePTOLetterFilter()}
        size="small"
        sx={{ padding: "4px" }}
      />
      <Typography
        variant="caption"
        sx={{ fontSize: "0.75rem", lineHeight: 1.2 }}
      >
        PTO Letter Submitted
      </Typography>
    </Box>
  );
};

export default PtoLetterCheckbox;
